// Package Imports
import { TrophyOutlined } from '@ant-design/icons';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

const ContestResource: ResourceItem = {
  name: resourceName.contest,
  identifier: ModuleIdentifierConst.CONTEST,
  list: `${resourceName.contest}`,
  create: `${resourceName.contest}/create`,
  edit: `${resourceName.contest}/edit/:id`,
  show: `${resourceName.contest}/show/:id`,
  options: {
    label: 'Contest',
    icon: <TrophyOutlined style={{ fontSize: 20 }} />,
  },
};

export default ContestResource;
